<template>
  <v-footer
    id="core-footer"
    bottom fixed 
    height="52"
  >
    <div class="footer-items">
      <v-img v-if='showLogo' src='/img/logo.png'/>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      v.{{ version }}
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://www.depalop.com/"
        target="_blank">Depalop</a>, made with
      <v-icon
        color="tertiary"
        size="17">mdi-heart</v-icon>
      for a better world
    </span>
  </v-footer>
</template>

<script>
const { version } = require('../../../package.json')

export default {
  props: {
    showLogo: { type: Boolean, deafult: false }
  },
  data: () => ({
    version
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
  background-color:#E7E7E7;
}
</style>
